export default {
  'title': 'Card details',
  'props': [
    {
      'label': 'Card name',
      'id': 'name',
      'type': 'type_text',
      'field': 'name',
      'required': true,
      'editable': true,
      'tooltip': 'Your name as embossed on front of card',
      'value': '',
      'validation': [{'msg': '"Name" is required',
                      'rule': 'required'}]
    }
  ]
}




// WEBPACK FOOTER //
// ./src/components/forms/_data/stripe.js